import { render, staticRenderFns } from "./xiao-fei-zhe-dong-cha.vue?vue&type=template&id=6974046a&scoped=true"
import script from "./xiao-fei-zhe-dong-cha.vue?vue&type=script&lang=js"
export * from "./xiao-fei-zhe-dong-cha.vue?vue&type=script&lang=js"
import style0 from "./xiao-fei-zhe-dong-cha.vue?vue&type=style&index=0&id=6974046a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974046a",
  null
  
)

export default component.exports